export default __webpack_public_path__ + "a13e19811a080da1963febb115d40dfe.png";